<template lang="html">
  <div
    id="wrapper"
    ref="wrapper"
  >
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout ma-0>
              <v-flex pa-0>
                Services guide
              </v-flex>
              <v-btn 
                v-if="dirty.servicesGuide" 
                depressed 
                color="primary" 
                @click="savePage('servicesGuide')"
              >
                Save
              </v-btn>
            </v-layout>
          </v-card-title>
          <SiQuill
            v-model="servicesGuide"
            rounded-corners-bottom
            hide-details
            :anchor-toolbar-ref="$refs.wrapper"
            @change="dirty.servicesGuide = true"
          />
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout ma-0>
              <v-flex pa-0>
                Privacy Policy
              </v-flex>
              <v-btn 
                v-if="dirty.privacyPolicy" 
                depressed 
                color="primary" 
                @click="savePage('privacyPolicy')"
              >
                Save
              </v-btn>
            </v-layout>
          </v-card-title>
          <SiQuill
            v-model="privacyPolicy"
            rounded-corners-bottom
            hide-details
            :anchor-toolbar-ref="$refs.wrapper"
            @change="dirty.privacyPolicy = true"
          />
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { rtdb } from "@/plugins/firebase";
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";

export default {
  mixins: [helpers, binder],
  data() {
    return {
      servicesGuide: "",
      privacyPolicy: "",
      dirty: {},
    };
  },
  computed: {
    ...mapGetters(["_loader"]),
  },
  watch: {
    servicesGuide(v, ov) {
  
      if (!ov && v) {
        this.$nextTick(() => (this.dirty = { ...this.dirty, servicesGuide: false}));
      }
    },
  },
  beforeMount() {
    this.$bindRtdb("servicesGuide", "site/pages/servicesGuide/html", {
      loader: true,
      defaultData: "",
    });
    this.$bindRtdb("privacyPolicy", "site/pages/privacyPolicy/html", {
      loader: true,
      defaultData: "",
    });
    this.$store.commit('set_appBarTitle', { title: 'Legals', icon: 'policy' })

  },
  methods: {
    savePage(key) {
      rtdb.ref(`site/pages/${key}`).set({
        updated: new Date().toISOString(),
        html: this[key],
      });
      this.dirty = { ...this.dirty, [key]: false}
    },
  },
};
</script>

<style lang="css" scoped>
</style>
